exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cls-1{fill:#fff;stroke:#7e7e7e;stroke-linecap:round;stroke-linejoin:round;stroke-width:.46px}", ""]);

